import React from 'react';
import {Icon} from '../../icons';
import {IconNames} from '../../icons/types';
import {Layout} from '../../layout';
import {Spacer} from '../../spacer';

type Props = {
  index: number | undefined;
  icons: IconNames[] | undefined;
  onRenderBadge?: (index: number) => React.ReactElement | null;
};

export const BadgeOrIcon: React.FC<Props> = ({index, icons, onRenderBadge}) => {
  if (index === undefined || index === -1) {
    return null;
  }
  let Element: React.ReactElement | null = null;
  if (onRenderBadge) {
    Element = onRenderBadge(index);
  }
  if (!Element && icons && icons[index]) {
    Element = (
      <Icon name={icons[index]} color="content_mono_secondary" size="16" />
    );
  }
  return Element ? (
    <Layout horizontal align="center">
      {Element}
      <Spacer width="10" />
    </Layout>
  ) : null;
};
